import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateReturnInvoiceStepperComponent } from './create-return-invoice-stepper.component';
import { ReturnSaveStepModule } from './return-save-step/return-save-step.module';

@NgModule({
  declarations: [CreateReturnInvoiceStepperComponent],
  imports: [
    CommonModule,
    ReturnSaveStepModule
  ],
  exports: [CreateReturnInvoiceStepperComponent]
})
export class CreateReturnInvoiceStepperModule { }
